module.exports = function (string) {
  return string.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&")
}



//////////////////
// WEBPACK FOOTER
// ./~/regexp-quote/regexp-quote.js
// module id = 763
// module chunks = 0